import { DecimalPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Robot } from 'src/app/models/robot';
import { ACTIONS } from 'src/app/shared/constants/general-constants';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { DeleteRobots, LoadOwnerRobots, QaState, ReloadOwnerRobots } from '../redux';
import { EditMyRobotsComponent } from './edit-my-robots/edit-my-robots.component';
import { ViewMyRobotsComponent } from './view-my-robots/view-my-robots.component';

@Component({
  selector: 'app-my-robots',
  templateUrl: './my-robots.component.html',
  styleUrls: ['./my-robots.component.css'],
  providers: [DecimalPipe],
  standalone: true,
  imports: [SharedModule]
})
export class MyRobotsComponent implements OnInit, OnDestroy {
  public robot$: Observable<any[]> = inject(Store).select(QaState.ownerRobots);
  private unsubscribe = new Subject<void>();

  public tableData;
  public showActions = [ACTIONS.CREATE, ACTIONS.EDIT, ACTIONS.CLONE, ACTIONS.DELETE];

  constructor(
    private store: Store,
    private dialogService: NbDialogService
  ) {
    if (!this.store.selectSnapshot(QaState.ownerRobots)) {
      this.store.dispatch(LoadOwnerRobots);
    }
  }

  public ngOnInit(): void {
    this.robot$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public clickedButton($event) {
    if ($event.action === ACTIONS.REFRESH) {
      this.tableData = undefined;
      this.store.dispatch(ReloadOwnerRobots);
    }
    if ($event.action === ACTIONS.CREATE) {
      this.dialogService.open(EditMyRobotsComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          robot: new Robot()
        }
      });
    }
    if ($event.action === ACTIONS.VIEW) {
      const robot: Robot = $event.data;
      this.dialogService.open(ViewMyRobotsComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          robot
        }
      });
    }
    if ($event.action === ACTIONS.EDIT) {
      const robot: Robot = $event.data;
      this.dialogService.open(EditMyRobotsComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          robot: Robot.copy(robot)
        }
      });
    }
    if ($event.action === ACTIONS.CLONE) {
      const robot: Robot = $event.data;
      this.dialogService.open(EditMyRobotsComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          robot: Robot.copy(robot)
        }
      });
    }
    if ($event.action === ACTIONS.DELETE) {
      const robot: Robot = $event.data;
      this.dialogService
        .open(NgxGenericModalComponent, {
          closeOnEsc: false,
          closeOnBackdropClick: false,
          context: {
            title: $localize`Are you sure you want to delete Robot`,
            message: robot.name
          }
        })
        .onClose.subscribe((data) => {
          if (data === true) {
            const robotToDelete = Robot.copy(robot);
            robotToDelete.deleted = true;
            this.store.dispatch(new DeleteRobots(robotToDelete));
          }
        });
    }
  }
}
